import { type AppThunk } from "../../../index";
import { clearDishSearchTerm } from "../reducer";
import { fetchDishes } from "./fetchDishes";

export const clearSearchingDish = (): AppThunk => (dispatch) => {
  dispatch(clearDishSearchTerm());
  void dispatch(fetchDishes());
};
